import React, { useEffect, useState } from 'react';

const VotosEspeciales = ({ form, isReadonly, onVotoChange, initialData = {}, isEditing = false, resetTrigger = 0 }) => {
  const [votosEspeciales, setVotosEspeciales] = useState({
    blancos: { concejales: 0, legisladores_provinciales: 0 },
    impugnados: { concejales: 0, legisladores_provinciales: 0 }
  });

  // Cargar datos iniciales en modo edición
  useEffect(() => {
    if (isEditing && initialData && Object.keys(initialData).length > 0) {
      console.log('🔄 Cargando datos iniciales de votos especiales:', initialData);

      const nuevosVotos = {
        blancos: { concejales: 0, legisladores_provinciales: 0 },
        impugnados: { concejales: 0, legisladores_provinciales: 0 }
      };

      // Nuevo formato: con cargos separados
      if (initialData.blancos && typeof initialData.blancos === 'object') {
        nuevosVotos.blancos = {
          concejales: initialData.blancos.concejales || 0,
          legisladores_provinciales: initialData.blancos.legisladores_provinciales || 0
        };
      } else if (initialData.blancos !== undefined) {
        // Formato antiguo: sin cargos, asignar a legisladores_provinciales
        nuevosVotos.blancos.legisladores_provinciales = initialData.blancos || 0;
      }

      if (initialData.impugnados && typeof initialData.impugnados === 'object') {
        nuevosVotos.impugnados = {
          concejales: initialData.impugnados.concejales || 0,
          legisladores_provinciales: initialData.impugnados.legisladores_provinciales || 0
        };
      } else if (initialData.impugnados !== undefined) {
        // Formato antiguo: sin cargos, asignar a legisladores_provinciales
        nuevosVotos.impugnados.legisladores_provinciales = initialData.impugnados || 0;
      }

      setVotosEspeciales(nuevosVotos);
      form.setValue('especiales', nuevosVotos);

      console.log('✅ Datos iniciales de votos especiales cargados:', nuevosVotos);
    }
  }, [isEditing, initialData]);

  // Reset cuando cambie resetTrigger (solo si no estamos en modo edición)
  useEffect(() => {
    if (resetTrigger > 0 && !isEditing) {
      console.log('🔄 Reseteando votos especiales por resetTrigger:', resetTrigger);
      const votosLimpios = {
        blancos: { concejales: 0, legisladores_provinciales: 0 },
        impugnados: { concejales: 0, legisladores_provinciales: 0 }
      };
      setVotosEspeciales(votosLimpios);
      form.setValue('especiales', votosLimpios);
    }
  }, [resetTrigger, isEditing]);

  const handleVotoChange = (tipo, cargo, valor) => {
    const nuevoValor = Math.max(0, parseInt(valor) || 0);

    const nuevosVotos = {
      ...votosEspeciales,
      [tipo]: {
        ...votosEspeciales[tipo],
        [cargo]: nuevoValor
      }
    };

    setVotosEspeciales(nuevosVotos);
    form.setValue('especiales', nuevosVotos);

    if (onVotoChange) {
      onVotoChange(tipo, cargo, nuevoValor);
    }

    console.log(`🎯 Voto especial ${tipo} ${cargo} actualizado:`, nuevoValor);
  };

  return (
    <div className="card mb-4">
      <div className="card-header bg-warning text-dark">
        <h5 className="mb-0">
          <i className="fas fa-exclamation-triangle me-2"></i>
          Votos Especiales
        </h5>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table table-bordered table-hover">
            <thead className="table-warning">
              <tr>
                <th className="text-center" style={{ width: '50%' }}>
                  <i className="fas fa-info-circle me-2"></i>
                  TIPO DE VOTO
                </th>
                <th className="text-center" style={{ width: '25%' }}>
                  <i className="fas fa-landmark me-2"></i>
                  DIPUTADOS O SENADORES PROVINCIALES
                </th>
                <th className="text-center" style={{ width: '25%' }}>
                  <i className="fas fa-user-tie me-2"></i>
                  CONCEJALES Y CONSEJEROS ESCOLARES
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="fw-bold text-dark">
                  <i className="fas fa-circle me-2"></i>
                  VOTOS EN BLANCO
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control text-center"
                    value={votosEspeciales.blancos.legisladores_provinciales}
                    onChange={(e) => handleVotoChange('blancos', 'legisladores_provinciales', e.target.value)}
                    readOnly={isReadonly}
                    min="0"
                    style={{ fontWeight: 'bold' }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control text-center"
                    value={votosEspeciales.blancos.concejales}
                    onChange={(e) => handleVotoChange('blancos', 'concejales', e.target.value)}
                    readOnly={isReadonly}
                    min="0"
                    style={{ fontWeight: 'bold' }}
                  />
                </td>
              </tr>
              
              <tr>
                <td className="fw-bold text-dark">
                  <i className="fas fa-gavel me-2"></i>
                  VOTOS IMPUGNADOS
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control text-center"
                    value={votosEspeciales.impugnados.legisladores_provinciales}
                    onChange={(e) => handleVotoChange('impugnados', 'legisladores_provinciales', e.target.value)}
                    readOnly={isReadonly}
                    min="0"
                    style={{ fontWeight: 'bold' }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    className="form-control text-center"
                    value={votosEspeciales.impugnados.concejales}
                    onChange={(e) => handleVotoChange('impugnados', 'concejales', e.target.value)}
                    readOnly={isReadonly}
                    min="0"
                    style={{ fontWeight: 'bold' }}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default VotosEspeciales;
